import { Map } from 'immutable';
import { QUIZ_KEY, QUIZ_RESULTS_KEY, QUIZ_REWARDS_KEY, QUIZ_STAGE_KEY } from './reducers';

/**
 * Get the value of the stage field of the quiz task.
 */
export function getQuizTaskStage(state, taskId) {
    return state.getIn([QUIZ_KEY, taskId, QUIZ_STAGE_KEY]);
}

/**
 * Get the results of any previous quizzes.
 */
export function getPreviousQuizResults(state) {
    return state.getIn([QUIZ_KEY, QUIZ_RESULTS_KEY]);
}

/**
 * Get entire state for a quiz task.
 */
export function getQuizTaskState(state, taskId) {
    return state.getIn([QUIZ_KEY, taskId]);
}

/**
 * Get the value of the rewards field of the quiz task.
 */
export function getQuizRewards(state, taskId) {
    return state.getIn([QUIZ_KEY, taskId, QUIZ_REWARDS_KEY]) || Map();
}
